import { TransportModeHelper } from '../../../../helpers/transport-mode.helper';
import { TransportSubModeHelper } from '../../../../helpers/transport-sub-mode.helper';
import { ILine } from '../../../../models/line.model';

export class LineApiModel {
  gid!: string;
  technicalLineNumber!: string;
  name!: string;
  shortName!: string;
  directionName!: string;
  backgroundColor!: string;
  foregroundColor!: string;
  borderColor!: string;
  transportMode!: string;
  transportSubMode!: string;
  designation?: string;
  transportAuthorityGid?: string;

  public static mapToBusinessModel(apiModel: LineApiModel): ILine {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
      shortName: apiModel.shortName,
      technicalLineNumber: apiModel.technicalLineNumber,
      directionName: apiModel.directionName,
      backgroundColor: apiModel.backgroundColor,
      foregroundColor: apiModel.foregroundColor,
      borderColor: apiModel.borderColor,
      transportMode: TransportModeHelper.parse(apiModel.transportMode),
      transportSubMode: TransportSubModeHelper.parse(apiModel.transportSubMode),
      contractorId: undefined,
      isPublicTransport: undefined,
      isWheelchairAccessible: undefined,
      municipalities: undefined,
      appliesFrom: undefined,
      appliesUpto: undefined,
      designation: apiModel.designation,
      transportAuthorityGid: apiModel.transportAuthorityGid,
    };
  }
}
